module.exports = __webpack_public_path__ + "static/media/cert_-1.7dfb1de9.jpg";